import { start } from "countup";

const getMonthNumber = (monthName) => {
  var months = {
    janvier: 0,
    février: 1,
    mars: 2,
    avril: 3,
    mai: 4,
    juin: 5,
    juillet: 6,
    août: 7,
    septembre: 8,
    octobre: 9,
    novembre: 10,
    décembre: 11,
  };

  return months[monthName.toLowerCase()];
};

const formatDate = (date) => {
  const parts = date.split(" ");

  const day = Number(parts[1], 10);
  const month = getMonthNumber(parts[2]);
  const year = Number(parts[3], 10);

  const newDate = new Date(year, month, day);

  return newDate;
};

const filterIncident = (ligne, time, currentIncidents) => {
  currentIncidents.forEach((incident) => {
    const impactedLigne = incident.querySelector("h3");
    const impactedTime = incident.querySelector(".date-incident").textContent;
    const formatedImpactedTime = formatDate(impactedTime);
    const currentTime = new Date();
    const startOfDayIncident = new Date(
      formatedImpactedTime.getFullYear(),
      formatedImpactedTime.getMonth(),
      formatedImpactedTime.getDate()
    );
    const startOfDayCurrentTime = new Date(
      currentTime.getFullYear(),
      currentTime.getMonth(),
      currentTime.getDate()
    );
    let ligneBool = true;
    let timeBool = true;

    if (ligne) {
      ligneBool = impactedLigne.textContent === ligne;
    }

    if (time) {
      if (time === "now") {
        timeBool =
          startOfDayIncident.getTime() === startOfDayCurrentTime.getTime();
      } else if (time === "future") {
        timeBool =
          startOfDayIncident.getTime() > startOfDayCurrentTime.getTime();
      }
    }

    if (ligneBool && timeBool) {
      incident.style.display = "flex";
    } else {
      incident.style.display = "none";
    }
  });
};

export { filterIncident };
